module.exports = __webpack_public_path__ + "img/rules__goal.677f4a53.png";